var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"lesson-audios d-flex flex-column"},_vm._l((_vm.audios),function(audio,index){return _c('div',{key:index,staticClass:"mb-2"},[_c('iframe',{staticClass:"w-100 border-0",attrs:{"src":_vm.src(audio),"height":_vm.iframeHeight(audio)}})])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }